/**
 * Las dos vistas del módulo: tendencias y exportaciones.
 *
 * Van como pestañas dentro del módulo y no como dos entradas del menú lateral
 * porque `nav.ts` es un archivo compartido por los diez módulos de B6 — cuanto
 * menos lo toque cada uno, menos choques hay. Y conceptualmente son lo mismo:
 * el CSV es la misma analítica, para llevar.
 */
import { NavLink } from 'react-router-dom';
import type { ReactNode } from 'react';

import { useI18n } from '@/i18n/useI18n';
import { cn } from '@/ui/cn';

const TABS = [
  { to: '/analytics', end: true, key: 'analytics.tab.trends' },
  { to: '/analytics/exports', end: false, key: 'analytics.tab.exports' },
] as const;

export function AnalyticsTabs(): ReactNode {
  const { t } = useI18n();

  return (
    <nav aria-label={t('analytics.tab.label')} className="flex gap-1 border-b border-border">
      {TABS.map((tab) => (
        <NavLink
          key={tab.to}
          to={tab.to}
          end={tab.end}
          className={({ isActive }) =>
            cn(
              'border-b-2 px-3 py-2 text-sm font-medium',
              isActive
                ? 'border-accent text-ink'
                : 'border-transparent text-ink-muted hover:text-ink',
            )
          }
        >
          {t(tab.key)}
        </NavLink>
      ))}
    </nav>
  );
}
